import React from "react";
import "./InfoShowcase.css";
import { SocialBar } from "../SocialBar/SocialBar.js";

import { extractDetailData } from "../../utility/utility.js";

export const InfoShowcase = (props) => {
  const { detailData } = props;

  //Extract Info below
  //const type = detailData.type; const id = detailData.id;

  //Main Info
  const title = detailData.title;
  const director = detailData.credits.director
    ? detailData.credits.director[0]
    : null;
  const createdBy = detailData.created_by;
  //Poster
  const posterPath = detailData.poster_path;
  //Certification or Network
  const certification = detailData.certification?.certification;
  const networks = detailData.networks ? detailData.networks : null;
  //Overview
  const overview = detailData.overview;
  //Semi Info
  const semiInfo = {
    releaseDate: detailData.release_date,
    country: detailData.country ? detailData.country : null,
    runtime: detailData.runtime,
  };
  //Others Info
  const others = detailData.others;
  //Cast Info
  const cast = detailData.credits.cast.slice(0, 7);
  //Tagline
  const tagline = detailData.tagline;

  return (
    <div className="mov_info_showcase_wrapper">
      <div className="mov_info_showcase_upper">
        <SocialBar />
        <div className="mov_info_showcase info_showcase_container">
          <MainInfoSection
            director={director}
            createdBy={createdBy}
            title={title}
          />
          <div className="info_showcase certification_container">
            <div className="certifcation_details">
              {certification || networks}
            </div>
          </div>
          <SemiInfoSection semiInfo={semiInfo} />
          <div className="info_showcase overview">{overview}</div>
          <div className="info_showcase other_and_credit_wrapper">
            <OtherInfoColumn others={others} />
            <CreditInfoColumn cast={cast} columnName={"CAST"} />
          </div>
        </div>
        <div className="mov_info_showcase poster_showcase_container">
          <img className="mov_info_showcase poster" src={posterPath} />
        </div>
      </div>
      <div className="mov_info_showcase_tagline">{'"' + tagline + '"'}</div>
    </div>
  );
};

const MainInfoSection = (props) => {
  let { director, createdBy, title } = props;
  return (
    <div className="info_showcase main_info">
      <div className="info_showcase director">
        {director ? director.name : "" || createdBy}
      </div>
      <div className="info_showcase title">{title}</div>
    </div>
  );
};

const SemiInfoSection = (props) => {
  let { semiInfo } = props;

  return (
    <div className="info_showcase semi_info">
      <div className="info_showcase semi_info_title">FILM INFO</div>
      <span className="semi_info_breakline"></span>
      <div className="info_showcase semi_info_details">
        {Object.keys(semiInfo).map((infoType) =>
          semiInfo[infoType] !== null ? (
            <div className={`info_showcase ${infoType}`} key={infoType}>
              {semiInfo[infoType]}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

const OtherInfoColumn = (props) => {
  let { others } = props;
  return (
    <div className="info_showcase other_info_container">
      {Object.keys(others).map((infoType) => (
        <div className={`info_showcase other_info ${infoType}`} key={infoType}>
          <span className={`other_info_title ${infoType}`}>
            {infoType.replace(/_/g, " ").toUpperCase()}
          </span>
          <span className="other_info_details">{others[infoType]}</span>
        </div>
      ))}
    </div>
  );
};

const CreditInfoColumn = (props) => {
  let { cast, columnName } = props;
  return (
    <div className="info_showcase credit_info_container">
      <div className="credit_info_title">{columnName}</div>
      {cast.length == 0 ? (
        <div>Sorry, no information found</div>
      ) : (
        cast.map(({ name, character }, index) => (
          <div className={`credit_info cast_info`} key={index}>
            <span className="credit_info_name">{name}</span>
            <span className="credit_info_breakline"></span>
            <span className="credit_info_role">{character}</span>
          </div>
        ))
      )}
    </div>
  );
};
